@if (isLoading) {
    <div class="fancy-loader"></div>
} @else {
    <div>
        <form-linkable
            displayValueProp="name"
            [parentGuid]="parentGuid"
            [linkedModule]="linkedModule"
            [linkedForms]="linkedForms"
            [linked]="linked"
            [unlinked]="unlinked"
            [disabled]="disabled"
            [hideActions]="true"
            (linkedChange)="linkedItemsChanged($event)"
            data-uiid="auditforms-linkable"
        ></form-linkable>
    </div>
}
